import { FormControl, FormGroup } from '@angular/forms';
import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '@app/layouts/components/sidebar/sidebar.component';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { Router } from '@angular/router';
import { TokenService } from '@app/auth/token.service';


interface User{
    email: string,
    documento: string,
    nombreUsuario: string
  }

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
    private listTitles: any[];
    private email: string ;
    private documento: string ;
    private nombreUsuario: string;
    location: Location;
      mobile_menu_visible: any = 0;
    private toggleButton: any;
    private sidebarVisible: boolean;
    texto = '';
    constructor(
        location: Location,
        private element: ElementRef,
        private router: Router,
        public tokenService: TokenService
    ) {
      this.location = location;
          this.sidebarVisible = false;
    }

    ngOnInit() {
        console.log( this.tokenService.getToken());
        let user: User
        user = this.tokenService.getUser();

        this.documento = user.documento;
        this.email = user.email;
        this.nombreUsuario = user.nombreUsuario;


      this.listTitles = ROUTES.filter(listTitle => listTitle);
      const navbar: HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
      this.router.events.subscribe((event) => {
        this.sidebarClose();
         const $layer: any = document.getElementsByClassName('close-layer')[0];
         if ($layer) {
           $layer.remove();
           this.mobile_menu_visible = 0;
         }
     });
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function() {
            toggleButton.classList.add('toggled');
        }, 500);

        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    };

    getTitle() {
      let titlee = this.location.prepareExternalUrl(this.location.path());
      if (titlee.charAt(0) === '#') {
          titlee = titlee.slice( 1 );
      }

      for (let item = 0; item < this.listTitles.length; item++) {
          if (this.listTitles[item].path === titlee) {
              return this.listTitles[item].title;
          }
      }
      return 'Registro Nacional Fluvial';
    }

    salir() {
        this.tokenService.clearToken();
        this.router.navigate(['/login']);
    }
}
